// api/subscribeRedirectsPaginatedAndFiltered.ts
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { registerSubscription } from "@adornis/baseql/metadata/register.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import { watchQuery } from "@adornis/baseql/server/watchQuery.js";
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
import { map } from "rxjs";
import { Redirect } from "../db/Redirect.js";
var subscribeRedirectsPaginatedFilteredResolver = (skip, limit, filter) => {
  return (gqlFields) => {
    return watchQuery(Redirect._collectionName, {}).pipe(
      map(async () => {
        const rawCollection = await getRawCollection(Redirect._collectionName);
        const result = await rawCollection.aggregate([
          {
            $match: {
              $or: [
                {
                  from: { $regex: filter?.search ?? "", $options: "i" }
                },
                {
                  to: { $regex: filter?.search ?? "", $options: "i" }
                }
              ]
            }
          },
          { $skip: skip },
          { $limit: limit }
        ]).toArray();
        return result;
      })
    );
  };
};
var subscribeRedirectsPaginatedFiltered = registerSubscription({
  type: () => [Redirect],
  operationName: "subscribeRedirectsPaginatedFiltered",
  resolve: subscribeRedirectsPaginatedFilteredResolver,
  params: [
    { type: () => Int, name: "skip" },
    { type: () => Int, name: "limit" },
    { type: () => AdornisFilter, name: "filter" }
  ]
});
export {
  subscribeRedirectsPaginatedFiltered
};
